    // src/redux/slices/authSlice.js
    import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
    import axios from "axios";
    import { ApiBaseUrl, clientLogout } from "../../Utils/Constants";
    import { showToast } from "../../Helper/Toast";

    export const hitLogoutClientApi = createAsyncThunk("hitLogoutClientApi", async () => {
      try {
        const config = {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `${localStorage.getItem("clientToken")}`,
          },
        };
        //console.log("LogoutClientSlice - Authorization Header:", config.headers.Authorization); 
        const url = ApiBaseUrl + clientLogout;
        const response = await axios.put(url, {}, config);
        return response.data;
      } catch (error) {
        showToast(error.response.data.message, "error");
        throw error.response.data;
      }
    });
    
    const LogoutClientSlice = createSlice({
      name: "logoutClientReducer",
      initialState: {
        isLoading: false,
        data: null,
      },
      reducers: {
        clearhitLogoutClientData: (state) => {
          state.data = null;
        },
      },
      extraReducers: (builder) => {
        builder
          .addCase(hitLogoutClientApi.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(hitLogoutClientApi.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
          })
          .addCase(hitLogoutClientApi.rejected, (state) => {
            state.isError = false;
          });
      },
    });
    
    export const { clearhitLogoutClientData } = LogoutClientSlice.actions;
    export default LogoutClientSlice.reducer;
    